module.exports = __webpack_public_path__ + "static/media/img_image@2x.257d685f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_image@2x.jpg
// module id = 1010
// module chunks = 0